import DisciplineDetail from "@/pages/DisciplineDetail";

export default function DifesaPersonale() {
  return <DisciplineDetail slug="difesa-personale" />;
}
